// インドの森: トースト通知（カート追加時等）
// 2026-04-28 追加。cart_type=drawer時もカート追加感の即時フィードバックを補助
(function () {
  let toastEl = null;

  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'inm-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function show(message, type) {
    const el = ensureToast();
    el.className = 'inm-toast' + (type ? ' inm-toast--' + type : '');
    el.innerHTML = (type === 'success' ? '<span class="inm-toast__icon" aria-hidden="true">✓</span>' : '') + '<span>' + message + '</span>';
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2600);
  }

  // Hook fetch for cart adds
  const origFetch = window.fetch;
  window.fetch = function () {
    const url = String(arguments[0] || '');
    const result = origFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1 && (!arguments[1] || (arguments[1].method || 'GET').toUpperCase() === 'POST')) {
      result.then(function (r) {
        if (r && r.ok) {
          show('カートに追加しました', 'success');
        }
      }).catch(function () {});
    }
    if (url.indexOf('/cart/change') !== -1 && arguments[1] && arguments[1].method && arguments[1].method.toUpperCase() === 'POST') {
      result.then(function (r) {
        if (r && r.ok) {
          show('カートを更新しました', 'success');
        }
      }).catch(function () {});
    }
    return result;
  };

  // Also hook XHR (legacy paths)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._inmUrl = url;
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    const xhr = this;
    xhr.addEventListener('load', function () {
      if (xhr._inmUrl && xhr._inmUrl.indexOf('/cart/add') !== -1 && xhr.status >= 200 && xhr.status < 300) {
        show('カートに追加しました', 'success');
      }
    });
    return origSend.apply(this, arguments);
  };
})();
